// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__k6bE1","emails":"CreateEditClinics_emails__gvQux","emailTagLabel":"CreateEditClinics_emailTagLabel__1bmfY"};